import { UIRenderer, Vec3, _decorator } from 'cc';
import ShaderManipulator from './ShaderManipulator';

const { ccclass, property, requireComponent, executeInEditMode } = _decorator;

@ccclass('HSLAdjuster')
@requireComponent(UIRenderer)
@executeInEditMode
export default class HSLAdjuster extends ShaderManipulator {
    @property
    private _hsl: Vec3 = Vec3.ZERO.clone();

    protected _target: UIRenderer = null;

    @property({ min: -180, max: 180, step: 1, slide: true })
    public set hue(value: number) {
        if (this._hsl.x === value) {
            return;
        }
        this._hsl.x = value;
        this.updateHueProperty();
    }
    public get hue() {
        return this._hsl.x;
    }

    @property({ min: -100, max: 100, step: 1, slide: true })
    public get saturation(): number {
        return this._hsl.y;
    }
    public set saturation(value: number) {
        if (this._hsl.y === value) {
            return;
        }
        this._hsl.y = value;
        this.updateSaturationProperty();
    }

    @property({ min: -100, max: 100, step: 1, slide: true })
    public get lightness(): number {
        return this._hsl.z;
    }
    public set lightness(value: number) {
        if (this._hsl.z === value) {
            return;
        }
        this._hsl.z = value;
        this.updateLightnessProperty();
    }

    public get hsl(): Readonly<Vec3> {
        return this._hsl;
    }
    public set hsl(value: Vec3) {
        if (this._hsl.equals(value)) {
            return;
        }
        this._hsl.set(value);
        this.syncProperty();
    }

    protected syncProperty() {
        this.updateHueProperty();
        this.updateSaturationProperty();
        this.updateLightnessProperty();
    }

    protected updateHueProperty() {
        const pass = this.targetPass;
        if (!pass) {
            return;
        }
        pass.setUniform(pass.getHandle('hue'), this._hsl.x);
    }

    protected updateSaturationProperty() {
        const pass = this.targetPass;
        if (!pass) {
            return;
        }
        pass.setUniform(pass.getHandle('saturation'), this._hsl.y / 100);
    }

    protected updateLightnessProperty() {
        const pass = this.targetPass;
        if (!pass) {
            return;
        }
        pass.setUniform(pass.getHandle('lightness'), this._hsl.z / 100);
    }
}
